import { Empty, ErrorBox, Loading, typeLabel } from '../components/ui';
import { api, type CardSummary, type Page } from '../lib/api';
import { errorText, toast, useAsync } from '../lib/store';

export function Trash() {
  const { data, error, loading, reload } = useAsync(() => api.get<Page<CardSummary>>('/trash'), []);
  const restore = async (c: CardSummary) => {
    try {
      await api.post(`/cards/${c.id}/restore`);
      toast(`Restored “${c.title}”`);
      reload();
    } catch (e) {
      toast(errorText(e), 'error');
    }
  };
  return (
    <>
      <h1>Trash</h1>
      <p class="muted">Deleted cards are kept for 30 days, then purged with their history.</p>
      {loading ? (
        <Loading />
      ) : error ? (
        <ErrorBox error={error} />
      ) : !data!.items.length ? (
        <Empty>Trash is empty.</Empty>
      ) : (
        <ul class="rev-list">
          {data!.items.map((c) => (
            <li class="row-between" style={{ padding: 'var(--bk-space-3) 0' }}>
              <span>
                <span class="dr-plate">{typeLabel(c.type)}</span> <strong>{c.title}</strong>{' '}
                <span class="muted small">deleted {new Date(c.deleted_at!).toLocaleDateString()}</span>
              </span>
              <button class="dr-btn bk-sm" onClick={() => restore(c)}>
                Restore
              </button>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
